/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {TemplateQualitativeQuestionControlFunctionOperationalScopeDTO} from './TemplateQualitativeQuestionControlFunctionOperationalScopeDTO';

/**
 * The TemplateQualitativeQuestionDTO model module.
 * @module model/TemplateQualitativeQuestionDTO
 * @version v0
 */
export class TemplateQualitativeQuestionDTO {
  /**
   * Constructs a new <code>TemplateQualitativeQuestionDTO</code>.
   * @alias module:model/TemplateQualitativeQuestionDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TemplateQualitativeQuestionDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TemplateQualitativeQuestionDTO} obj Optional instance to populate.
   * @return {module:model/TemplateQualitativeQuestionDTO} The populated <code>TemplateQualitativeQuestionDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TemplateQualitativeQuestionDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('position'))
        obj.position = ApiClient.convertToType(data['position'], 'Number');
      if (data.hasOwnProperty('question'))
        obj.question = ApiClient.convertToType(data['question'], 'String');
      if (data.hasOwnProperty('supervisedEntity'))
        obj.supervisedEntity = ApiClient.convertToType(data['supervisedEntity'], 'Boolean');
      if (data.hasOwnProperty('notSupervisedEntity'))
        obj.notSupervisedEntity = ApiClient.convertToType(data['notSupervisedEntity'], 'Boolean');
      if (data.hasOwnProperty('driverCompletezza'))
        obj.driverCompletezza = ApiClient.convertToType(data['driverCompletezza'], 'Number');
      if (data.hasOwnProperty('driverAdeguatezza'))
        obj.driverAdeguatezza = ApiClient.convertToType(data['driverAdeguatezza'], 'Number');
      if (data.hasOwnProperty('driverFunzionalita'))
        obj.driverFunzionalita = ApiClient.convertToType(data['driverFunzionalita'], 'Number');
      if (data.hasOwnProperty('driverAffidabilita'))
        obj.driverAffidabilita = ApiClient.convertToType(data['driverAffidabilita'], 'Number');
      if (data.hasOwnProperty('templateQualitativeQuestionControlFunctionOperationalScopes'))
        obj.templateQualitativeQuestionControlFunctionOperationalScopes = ApiClient.convertToType(data['templateQualitativeQuestionControlFunctionOperationalScopes'], [TemplateQualitativeQuestionControlFunctionOperationalScopeDTO]);
      if (data.hasOwnProperty('tooltip'))
        obj.tooltip = ApiClient.convertToType(data['tooltip'], 'String');
      if (data.hasOwnProperty('displayId'))
        obj.displayId = ApiClient.convertToType(data['displayId'], 'Number');
    }
    return data;
  }
}

/**
 * @member {Number} id
 */
TemplateQualitativeQuestionDTO.prototype.id = undefined;

/**
 * @member {Number} position
 */
TemplateQualitativeQuestionDTO.prototype.position = undefined;

/**
 * @member {String} question
 */
TemplateQualitativeQuestionDTO.prototype.question = undefined;

/**
 * @member {Boolean} supervisedEntity
 */
TemplateQualitativeQuestionDTO.prototype.supervisedEntity = undefined;

/**
 * @member {Boolean} notSupervisedEntity
 */
TemplateQualitativeQuestionDTO.prototype.notSupervisedEntity = undefined;

/**
 * @member {Number} driverCompletezza
 */
TemplateQualitativeQuestionDTO.prototype.driverCompletezza = undefined;

/**
 * @member {Number} driverAdeguatezza
 */
TemplateQualitativeQuestionDTO.prototype.driverAdeguatezza = undefined;

/**
 * @member {Number} driverFunzionalita
 */
TemplateQualitativeQuestionDTO.prototype.driverFunzionalita = undefined;

/**
 * @member {Number} driverAffidabilita
 */
TemplateQualitativeQuestionDTO.prototype.driverAffidabilita = undefined;

/**
 * @member {Array.<module:model/TemplateQualitativeQuestionControlFunctionOperationalScopeDTO>} templateQualitativeQuestionControlFunctionOperationalScopes
 */
TemplateQualitativeQuestionDTO.prototype.templateQualitativeQuestionControlFunctionOperationalScopes = undefined;

/**
 * @member {String} tooltip
 */
TemplateQualitativeQuestionDTO.prototype.tooltip = undefined;

/**
 * @member {Number} displayId
 */
TemplateQualitativeQuestionDTO.prototype.displayId = undefined;

